<template>
    <div :id="uppyId">
        <div class="DashboardContainer"></div>
    </div>
</template>

<script>
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import XHRUpload from '@uppy/xhr-upload';
import locale from '../../locales/uppy.locale';
import Cookie from '../../system/cookie';

export default {
    name:  'Uppy',
    props: {
        metaFields:       {
            type:     Object,
            required: false,
            default:  () => {
            },
        },
        allowedFileTypes: {
            type:     Array,
            required: false,
            default:  () => ['image/*', 'application/pdf'],
        },
        maxFileSize:      {
            type:     [Number, Boolean],
            required: false,
            default:  () => false,
        },
        endpoint:         {
            type:     String,
            required: false,
            default:  () => '/upload'
        },
        note:             {
            type:     String,
            required: false,
            default:  () => null
        }
    },

    data() {
        return {
            uppy: null,
        }
    },

    computed: {
        uppyId() {
            return Math.random();
        }
    },

    mounted() {
        this.uppy = Uppy({
            id:           this.uppyId,
            autoProceed:  false,
            restrictions: {
                maxFileSize:      this.maxFileSize,
                allowedFileTypes: this.allowedFileTypes,
            },
            locale:       locale,
            meta:         this.metaFields,
        });

        this.uppy.on('complete', (files) => {
            this.$emit('complete', files)
        });

        this.uppy.on('upload-success', (file, response) => {
            const {status, body} = response;
            if (status === 201) {
                this.$emit('file-uploaded', body)
            }
        });

        this.uppy.use(Dashboard, {
            width:                       '100%',
            inline:                      true,
            target:                      '.DashboardContainer',
            replaceTargetContent:        true,
            note:                        this.note,
            proudlyDisplayPoweredByUppy: false,
            locale:                      locale,
            metaFields:                  [
                {id: 'fileName', name: 'Název souboru', placeholder: null},
            ]
        })
        this.uppy.use(XHRUpload, {
            endpoint: this.endpoint,
            locale:   locale,
            headers:  {
                'authorization': `Bearer ${this.$store.getters['user/token']}`
            },
        })
        this.uppy.run();
    },
    beforeDestroy() {
        this.uppy.close();
    },

    methods: {}
}
</script>

<style src="@uppy/core/dist/style.min.css"></style>
<style src="@uppy/dashboard/dist/style.min.css"></style>
<style src="@uppy/status-bar/dist/style.min.css"></style>

